import { IBasicError } from '../types/fetchData';
import { ELLIPSES } from './constants';

export const getXLastChars = (str: string, numberOfChars: number) => {
	if (str.length <= numberOfChars) {
		return str;
	}

	return str.slice(str.length - numberOfChars);
};

export const roundWithDecimal = (number: number, decimal: number = 100) => {
	return Math.round(number * decimal) / decimal;
};

export function truncateString(label: string, maxTagChars: number) {
	if (label.length <= maxTagChars) {
		return label;
	}
	return label.substring(0, maxTagChars) + ELLIPSES;
}

//https://johnumarattil.medium.com/truncating-middle-portion-of-a-string-in-javascript-173bfe1f9ae3
export const truncateStringMiddleEllipsis = (str: string, firstCharCount = str.length, endCharCount = 0) => {
	if (str.length <= firstCharCount + endCharCount) {
		return str;
	}

	const firstPart = str.slice(0, firstCharCount);
	const endPart = str.slice(-endCharCount);
	const ellipsis = '...';

	return `${firstPart}${ellipsis}${endPart}`;
};

export function filterCharacters(content: string, ...characters: string[]): string {
	return content.replace(new RegExp(`[${characters.join('')}]+`), '');
}

export function isErrorResponse<T>(response: T | IBasicError): response is IBasicError {
	return 'err' in response && !!response.err;
}

export const isEmptyValue = (value: string | number | readonly string[] | null | undefined): boolean => {
	return value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0);
};
